import { NotificationManager } from "react-notifications";
import { logout } from "../actions/UserActions";
import { store } from "../index";

export default function (error, component = null) {
	if (!error.response) {
		NotificationManager.error("Please make sure you are connected to internet.", "Can not connect to server!");
	} else {
		switch (error.response.status) {
		case 400:
			if (error.response.data && error.response.data.dublicate) {
				NotificationManager.error(error.response.data.dublicate,"Error!");
				break;
			}
			NotificationManager.error("Something went wrong!", error.response.statusText);
			break;
		case 401:
			store.dispatch(logout());
			NotificationManager.error("You must login to see this page.", "Unauthorized!");
			break;
		case 403:
			if (error.response.data && error.response.data.message) {
				NotificationManager.error(error.response.data.message, "Forbidden!");
				break;
			}
			NotificationManager.error("You are not allowed to access this page!", "Forbidden!");
			break;
		case 404:
			NotificationManager.error(error.response.data.message, error.response.statusText);
			break;
		case 413: 
			NotificationManager.error(error.response.data.message, error.response.statusText);
			break;
		case 422:
			NotificationManager.error("Some fields are missing or are not correct!", error.response.statusText);
			if (component) {
				const errors = {};
				Object.keys(error.response.data).forEach((key) => {
					errors[key] = error.response.data[key][0];
				});
				component.setState({ errors });
			}
			break;
		default:
			NotificationManager.error("Unhandled error", "Error!");
			break;
		}
	}
}


// WEBPACK FOOTER //
// ./src/services/HandleError.js